import { render, staticRenderFns } from "./urlAccessProhibit.vue?vue&type=template&id=800c4ba2"
import script from "./urlAccessProhibit.vue?vue&type=script&lang=js"
export * from "./urlAccessProhibit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports